import { render } from "./indicadorTreinos.vue?vue&type=template&id=1715ba1e&scoped=true"
import script from "./indicadorTreinos.vue?vue&type=script&lang=js"
export * from "./indicadorTreinos.vue?vue&type=script&lang=js"

import "./indicadorTreinos.vue?vue&type=style&index=0&id=1715ba1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1715ba1e"]])

export default __exports__